export const checkinmanual = {
    text1: "Check-in ręczny",
    text2: "Proszę wprowadzić dane wymagane do rejestracji gościa.",
    text3: "Informacje o zakwaterowaniu",
    text4: "Proszę wybrać obiekt *",
    text5: "Dane osobowe",
    text6: "Imię gościa *",
    text7: "Nazwisko gościa *",
    text8: "Mężczyzna",
    text9: "Kobieta",
    text10: "Wolę nie podawać",
    text11: "Inna",
    text12: "Proszę wybrać płeć *",
    text13: "Data urodzenia *",
    text14: "Numer telefonu *",
    text15: "Informacje o pobycie",
    text16: "Informacje o pobycie są obowiązkowe, aby kontynuować check-in. Proszę wypełnić wszystkie pola.",
    text17: "Od - Do",
    text18: "Do kiedy gość będzie przebywał w obiekcie?",
    text19: "E-mail gościa *",
    text20: "Proszę wybrać typ dokumentu.",
    text21: "Dowód osobisty",
    text22: "Paszport",
    text23: "Typ dokumentu",
    text24: "Numer dokumentu",
    text25: "Proszę wpisać numer dokumentu",
    text26: "Ważność dokumentu",
    text27: "Ważność dokumentu",
    text28: "Dalej",
    text29: "Check-in ręczny",
    text30: "Proszę wprowadzić dane wymagane do rejestracji gościa.",
    text31: "Podpis przy check-inie",
    text32: "Proszę podpisać się w szarym polu widocznym na ekranie",
    text33: "Zapisz check-in",
    text34: "Proces check-inu zakończony pomyślnie.",
    text35: "Aby przypisać check-in, trzeba wybrać obiekt",
    text36: "Pole imienia jest wymagane",
    text37: "Pole nazwiska jest wymagane",
    text38: "Pole płci jest wymagane",
    text39: "Pole daty urodzenia jest wymagane",
    text40: "Pole telefonu jest wymagane",
    text41: "Pole daty pobytu jest wymagane",
    text42: "Pole e-mail jest wymagane",
    text43: "Pole kraju jest wymagane",
    text44: "Pole typu dokumentu jest wymagane",
    text45: "Pole numeru dokumentu jest wymagane",
    text46: "Trzeba zaakceptować regulamin i warunki.",
    text47: "Wysyłanie danych check-inu, proszę czekać...",
    text48: "Wczytywanie...",
    text49: "check-in ukończony pomyślnie.",
    text50: "Proszę kliknąć tutaj, aby zobaczyć wszystkie nasze usługi dostępne w hotelu",
    text51: "Proszę wpisać imię",
    text52: "Proszę wpisać nazwisko",
    text53: "Kraj",
    text54: "Błąd",
    text55: "Proszę wpisać adres e-mail",

    // Corrections
    p1: "Data check-inu",
    p2: "Data check-outu",
    p3: "Data wydania dokumentu",
    p4: "",
    p5: "",
    p6: "",
    p7: "",
    p8: "",
};
